import ButtonGroupContainer  from "../../components/button/buttonGroup";

const ButtonGroup = () => {
  return <ButtonGroupContainer />;
};

export default ButtonGroup;
